import { WorkspaceCreateRequest, WorkspaceReadAllResponse, WorkspaceResponse } from "@/types/workspaceTypes";
import { Client } from "./client";
import { WorkspaceParams } from "@/backend/access/workspace/types";
import { FusaReply } from "@/types/replyTypes";

export class WorkspaceController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllForAdmin(): Promise<WorkspaceReadAllResponse> {
    return this.client.read('/api/workspaces/allForAdmin');
  }

  readAllByEnterpriseForAdmin(enterpriseId: string): Promise<WorkspaceReadAllResponse> {
    return this.client.read(`/api/workspaces/enterprise/${enterpriseId}`);
  }

  readAllByPropelOrgWithAssigned(): Promise<WorkspaceReadAllResponse> {
    return this.client.read('/api/workspaces/propelOrg/withAssigned');
  }

  create(data: WorkspaceCreateRequest): Promise<WorkspaceResponse> {
    return this.client.create('/api/workspaces', data);
  }

  update(data: WorkspaceParams): Promise<WorkspaceResponse> {
    return this.client.update(`/api/workspaces/${data.id}`, data);
  }

  updateExecutorEnterpriseId(workspaceId: string, executorEnterpriseId: string | undefined): Promise<WorkspaceResponse> {
    return this.client.update(`/api/workspaces/${workspaceId}/executor-enterprise/`, { executorEnterpriseId });
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/workspaces/${id}`);
  }

  read(id: string): Promise<WorkspaceResponse> {
    return this.client.read(`/api/workspaces/${id}`);
  }
}

